import Vue from 'vue'
import Router from 'vue-router'
import web_0 from '@/components/web_0'
import products from '@/components/products'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/products/:order_number',
      name: 'products',
      component: products
    }, {
      path: '/product/:order_number',
      name: 'product',
      component: products
    }, {
      path: '/',
      name: 'web_0',
      component: web_0
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js